import React from 'react';
import { getControlMenuPaperSx } from './controlTokens';

function ControlMenu({ children }) {
  return children;
}

export const buildControlMenuProps = (theme, context = 'filterBar', menuProps = {}) => ({
  ...menuProps,
  PaperProps: {
    ...(menuProps.PaperProps || {}),
    sx: {
      ...getControlMenuPaperSx(theme, context),
      ...(menuProps.PaperProps?.sx || {}),
    },
  },
});

export default ControlMenu;
